function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont20 = function SvgFont20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.754,
    height: 13.748
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25806",
    d: "M1.236.1a2.776 2.776 0 0 1 .434-1.524 2.741 2.741 0 0 1 1.208-1.032 18.479 18.479 0 0 0-2.416-.422 5.189 5.189 0 0 1 .8-2.78 5.165 5.165 0 0 1 2.156-1.877A7.194 7.194 0 0 1 6.585-8.2a6.762 6.762 0 0 1 2.944.61 4.7 4.7 0 0 1 1.982 1.7 4.549 4.549 0 0 1 .7 2.522v8.912h-3v-8.587a2.746 2.746 0 0 0-.786-2.029 2.807 2.807 0 0 0-2.076-.786 4.1 4.1 0 0 0-1.959.469 2.445 2.445 0 0 0-1.185 1.22 12.372 12.372 0 0 1 1.513.422 5.657 5.657 0 0 1 1.208.563v.845a2.663 2.663 0 0 0-1.255.892A2.3 2.3 0 0 0 4.239-.04v5.584h-3z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont20;